import { render } from "./VendorsFeesIndexButtonAdd.vue?vue&type=template&id=241701f0"
import script from "./VendorsFeesIndexButtonAdd.vue?vue&type=script&lang=js"
export * from "./VendorsFeesIndexButtonAdd.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__